import {bindable, inject} from "aurelia-framework";
import * as _ from "lodash";

export class EditableCell {
    @bindable field;
}
